import { Heading } from "@/components/ui/heading";
import { RegularPageLayout } from "@/components/layout/PageLayouts";
import { Link } from "react-router-dom";
export default function AboutPage() {
	const linkClass = "font-medium text-ink underline underline-offset-2";

	return (
		<RegularPageLayout width="6xl" paddingY="8">
			<section className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
				<Heading>About</Heading>
				<div className="mt-6 space-y-5 text-sm leading-7 text-slate-700 sm:text-base">
					<div>
						<p className="font-semibold text-slate-900">What is Text Formatter?</p>
						<p>
							Text Formatter helps teams turn raw text into clean, reusable content for websites,
							products, and internal tools. It is built for fast cleanup, consistent output, and
							repeatable formatting.
						</p>
					</div>

					<div>
						<p className="font-semibold text-slate-900">Why we built it</p>
						<p>
							Manual text cleanup is repetitive and easy to get wrong at scale. Text Formatter was
							created to remove that friction so people can focus on writing and shipping.
						</p>
					</div>

					<div>
						<p className="font-semibold text-slate-900">What makes it different</p>
						<p>
							You can use a simple web app for quick tasks or integrate the{" "}
							<a
								href="https://api.textformatter.pro"
								target="_blank"
								rel="noreferrer"
								className="font-medium text-ink underline underline-offset-2"
							>
								API
							</a>{" "}
							for automated workflows. The same formatting logic powers both, so behavior stays
							consistent across use cases.
						</p>
					</div>

					<div>
						<p className="font-semibold text-slate-900">Privacy and trust</p>
						<p>
							We aim to collect only what is needed to run and improve the service. For details, see
							our{" "}
							<Link className={linkClass} to="/privacy">
								Privacy Policy
							</Link>{" "}
							and{" "}
							<Link className={linkClass} to="/terms">
								Terms of Use
							</Link>
							.
						</p>
					</div>

					<div>
						<p className="font-semibold text-slate-900">Get started</p>
						<p>
							Try formatting{" "}
							<Link className={linkClass} to="/examples">
								examples
							</Link>{" "}
							in the app or use the API endpoint at{" "}
							<a
								href="https://api.textformatter.pro"
								target="_blank"
								rel="noreferrer"
								className={linkClass}
							>
								api.textformatter.pro
							</a>
							.
						</p>
						<p>
							You can get your API key in the{" "}
							<Link className={linkClass} to="/dashboard">
								dashboard
							</Link>
							.
						</p>
					</div>
				</div>
			</section>
		</RegularPageLayout>
	);
}
